import { createElement, useCallback, memo } from '@max/max';
import MaxButton from '@hfe/max-button';
import Text from '@hfe/max-text';
import './index.scss';
const isMRN = false;
const Button = ({ children, width = 136, height = 48, backgroundColor = '#FF2D19', fontSize = 32, handlePress, className = '' }) => {
    const handleOnPress = useCallback(() => {
        handlePress?.();
    }, [handlePress]);
    const buttonStyle = {
        width: `${width}rpx`,
        height: `${height}rpx`,
        backgroundColor,
        borderRadius: `${height / 2}rpx`
    };
    const textStyle = {
        fontSize: `${fontSize}rpx`
    };
    return <MaxButton className={`button-container ${className}`} style={buttonStyle} onPress={handleOnPress}>
      <Text className="button-text" style={textStyle}>
        {children}
      </Text>
    </MaxButton>;
};
export default memo(Button);
